import { Button } from "antd";
import React from "react";
import {
  PHONE_CONTACT,
  ROUTER_PATH,
  VERIFY_OTP_ERROR_CODES,
} from "../../common/constant";
import { localizeRouteKey } from "../../shared/helpers";

interface INotiyOTPFail {
  errorCode: string;
  markPhone: string;
  closeModal: () => void;
}

const NotifyOTPFail = (props: INotiyOTPFail) => {
  const { errorCode, markPhone, closeModal } = props;

  const onClick = () => {
    closeModal();
  };

  const showContent = () => {
    let ui = <></>;
    switch (errorCode) {
      case VERIFY_OTP_ERROR_CODES.VERIFY_OTP_RATE_LIMITED:
        ui = (
          <>
            <div>
              Số điện thoại {markPhone} của Quý khách đã được sử dụng để gửi
              vượt quá 10 mã xác nhận trong ngày.
            </div>
            <div>
              Vui lòng tạo tài khoản{" "}
              <a
                onClick={() => {
                  window.location.href = localizeRouteKey(ROUTER_PATH.SIGN_IN);
                }}>
                tại đây
              </a>{" "}
              để tiếp tục đặt hàng hoặc liên hệ tổng đài{" "}
              <a href={`tel:${PHONE_CONTACT}`}>{PHONE_CONTACT}</a> để được hỗ
              trợ.
            </div>
          </>
        );
        break;

      case VERIFY_OTP_ERROR_CODES.VERIFY_OTP_WRONG_OTP_MORE_THAN_5:
        ui = (
          <div>
            Quý khách đã nhập sai mã xác nhận quá 5 lần nên đơn hàng không được
            lưu thành công. Quý khách có thể đặt lại đơn hàng mới hoặc liên hệ
            tổng đài <a href={`tel:${PHONE_CONTACT}`}>{PHONE_CONTACT}</a> để
            được hỗ trợ.
          </div>
        );
        break;

      default:
        break;
    }
    return ui;
  };

  return (
    <div className="notify-otp-fail">
      {showContent()}

      <Button
        style={{ lineHeight: 1 }}
        className="kd-btn-primary-2 main-content"
        key="back"
        onClick={onClick}>
        {errorCode === VERIFY_OTP_ERROR_CODES.VERIFY_OTP_RATE_LIMITED
          ? "Đóng"
          : "Đồng ý"}
      </Button>
    </div>
  );
};

export default NotifyOTPFail;
